export function isInBetween(value: unknown, start: number, end: number): boolean {
  if (typeof value !== 'number') {
    return false;
  }

  return start <= value && value <= end;
}
